export default __webpack_public_path__ + "static/media/eduGreen.7d2ee272.svg";